import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class EditorTemplateComment extends BaseEntityModel {
  id?: number;
  commentId?: string;
  editorTemplateCommentThreadId?: number;
  editorTemplateId?: number;
  attributes?: Record<string, unknown>;
  content?: string;
  authorId?: number;

  constructor(model: Partial<EditorTemplateComment>) {
    super(model);

    this.id = model.id;
    this.commentId = model.commentId;
    this.editorTemplateId = model.editorTemplateId;
    this.attributes = model.attributes;
    this.editorTemplateCommentThreadId = model.editorTemplateCommentThreadId;
    this.content = model.content;
    this.authorId = model.authorId;
  }
}
